export default "__VITE_ASSET__BBf3YMk0__"